import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import WebMailBottom from '@/components/common/WebMailBottom.vue'
import * as dateutil from '@/util/date-helper'
import api from '@gnb/api'
import * as accountTypes from '@account/store/types'
import { mapGetters } from 'vuex'
@Component({
    components: { WebMailBottom },
    computed: {
        ...mapGetters({
            User: accountTypes.USER,
            userCurrent: accountTypes.CURRENT
        })
    },
})
export default class AlarmContainer extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    alarmList: home.AlarmItem[] = []

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    User!: account.User
    userCurrent!: account.TCurrent

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    loadData() {
        api.gnb.getWorkFeedList(this.User.personCode, this.User.comCode).then(res => {
            this.alarmList = res
            this.isloading(false)
        })
    }

    getDate(alarm: any) {
        return dateutil.uGetDateFormat('yyyy-MM-dd', dateutil.IEDate(alarm.createDate))
    }

    dateGroup() {
        const date =  this.alarmList.map(x => this.getDate(x))
        const dateGroup = Array.from(new Set(date))
        return dateGroup
    }

    getItems(date: any){
        const items = this.alarmList.filter(x => this.getDate(x) === date)
        return items
    }

    readFeed(alarm: any) {
        switch (alarm.alarmType) {
            case 'BB':
                this.$router.push({ path: `/board/read?id=${alarm.itemId}` })
                break
            case 'WF':
                this.$router.push({ path: `/workflow/read?apmid=${alarm.itemId}` })
                break
            case 'SC':
                break
            case 'CO':
                break
            case 'HA':
                break
            case 'DO':
                break
        }

        api.gnb.setWorkFeedReadStatus(alarm.alarmId, true).then((res: any) => {
            if (res > -1) {
              let nIdx = this.alarmList.findIndex((x) => x.alarmId == alarm.alarmId)
              if (nIdx > -1) this.alarmList.splice(nIdx, 1)
            }
        })
    }

    /**
     * type 에 따라 클래스명을 리턴합니다.
     * @param alarmType 
     */
    getFeedItemTypeClass(alarmType: string){
        var className = 'icon-email'
        switch(alarmType){
            case "WF":
                className = "icon-approval"
                break
            case "BB":
                className = "icon-email"
                break
        }
        return className
    }
    
    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        this.isloading(true)
        this.loadData()
    }
}
